<template>
    <div class="footer"></div>
</template>

<script>
    export default {
        created: function () {
        },
        mounted: function () {
        },
        data () {
            return {
                user: {
                    name: '',
                    email: '',
                    message: ''
                }
            }
        },
        methods: {
            sendEmail: function (e) {
                e.preventDefault()

                axios.post('api/v2/mail/send', this.user).then((response) => {
                    console.log(response)
                })
            }
        }
    }
</script>